import Failure from "../Pages/SSO/Failure/Failure";
import Success from "../Pages/SSO/Success/Success";

export const SSORoutes = [
  { path: "/sso-success", element: <Success /> },
  { path: "/sso-failure", element: <Failure /> },
];
